import { WebPlugin } from '@capacitor/core';
export class CapacitorShareTargetWeb extends WebPlugin {
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map